/** The panel shell's geometry: the page (#0C0C0C) carries flat #1A1A1A
 *  panels with a 14px radius and no border, 15px from the page edge and
 *  from each other (8px below the drawer breakpoint). Left column for
 *  the session list or admin menu, the centre for the page, and a right
 *  column that the session view fills in a later step. */
import { repoTokens } from "@/theme/tokens";

const shell = repoTokens.shell;

/** The look every shell panel shares. */
export const shellPanelSx = {
  bgcolor: repoTokens.colors.panel,
  borderRadius: `${shell.panelRadius}px`,
  border: "none",
  boxShadow: "none",
} as const;

/** Page edge to panel, and panel to panel: 8px on phones, 15px from md. */
export const shellGap = { xs: `${shell.phoneGap}px`, md: `${shell.gap}px` } as const;
